import CardModal from '../CardModal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import SVGArrow from '@/components/UI/svg/corporatesocialresponsibility/SVGArrow';

export default function E() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const [visible, setVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [active, setActive] = useState(0);

    const new_add_site_25_08_21 = ['eu', 'cn', 'fr', 'de', 'es', 'it', 'jp', 'us', 'ca', 'za', 'au', 'uk', 'mx'];

    const cards: any = [
        ...(new_add_site_25_08_21.includes(locale)
            ? [
                  {
                      title: t('secE_card16_text'),
                      desc: t('secE_card16_desc'),
                      webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                      img: 'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                      imgArr: [
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                              'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                          ],
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1753858618162/E16_2.jpeg',
                              'https://websiteoss.ecoflow.com/upload/image/1753858618162/E16_2.jpeg',
                          ],
                      ],
                  },
                  {
                      title: t('secE_card15_text'),
                      desc: t('secE_card15_desc'),
                      webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg',
                      img: 'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg',
                      imgArr: [
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg',
                          ],
                      ],
                  },
                  {
                      title: t('secE_card17_text'),
                      desc: t('secE_card17_desc'),
                      webpImg: 'https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg',
                      img: 'https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg',
                      imgArr: [
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg',
                              'https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg',
                          ],
                      ],
                  },
              ]
            : []),
        {
            title: t('secE_card10_text'),
            desc: t('secE_card10_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/A1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/A1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/A1.jpg'), require('@publicLocal/corporate-social-responsibility/common/A1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A2.jpg'), require('@publicLocal/corporate-social-responsibility/common/A2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A3.jpg'), require('@publicLocal/corporate-social-responsibility/common/A3.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A4.jpg'), require('@publicLocal/corporate-social-responsibility/common/A4.jpg')],
            ],
        },
        {
            title: t('secE_card11_text'),
            desc: t('secE_card11_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/B1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/B1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/B1.jpg'), require('@publicLocal/corporate-social-responsibility/common/B1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/B2.jpg'), require('@publicLocal/corporate-social-responsibility/common/B2.jpg')],
            ],
        },
        {
            title: t('secE_card1_text'),
            desc: t('secE_card1_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_1_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_1_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_1_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_1_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/5_1_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_1_2.png')],
            ],
        },
        {
            title: t('secE_card2_text'),
            desc: t('secE_card2_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_2_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_2_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/5_2_1.jpg')],
            ],
        },
        {
            title: t('secE_card3_text'),
            desc: t('secE_card3_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_3_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_3_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_3_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/5_3_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/h5/5_3_2.jpg'), require('@publicLocal/corporate-social-responsibility/h5/5_3_2.jpg')],
            ],
        },
        {
            title: t('secE_card4_text'),
            desc: t('secE_card4_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_4_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_4_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_4_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/5_4_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/h5/5_4_2.jpg'), require('@publicLocal/corporate-social-responsibility/h5/5_4_2.jpg')],
            ],
        },
        {
            title: t('secE_card5_text'),
            desc: t('secE_card5_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_5_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_5_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_5_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_5_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/5_5_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_5_2.png')],
            ],
        },
        {
            title: t('secE_card6_text'),
            desc: t('secE_card6_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_6_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_6_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_6_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_6_1.png')],
            ],
        },
        {
            title: t('secE_card7_text'),
            desc: t('secE_card7_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_7_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_7_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_7_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_7_1.png')],
            ],
        },
        {
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_8_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_8_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_8_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_8_1.png')],
            ],
            title: t('secE_card8_text'),
            desc: t(`secE_card8_desc`),
        },
        {
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/5_9_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/5_9_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/5_9_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/5_9_1.png')],
            ],
            title: t('secE_card9_text'),
            desc: t.rich(`secE_card9_desc`, {
                link: (text: string) => (
                    <a className="desc-link" href={'https://za.ecoflow.com/products/delta-max-portable-power-station'} target={'_blank'} rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
        },
    ];

    const clickCard = (card: any) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
        });
    };

    let originX = 0,
        startX = 0,
        endsX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        endsX = endX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const onTouchEnd = (e: any) => {
        const target = document.querySelector('.csr-E .card-lists') as HTMLDivElement;
        // if (endsX <= 0 && endsX >= window.innerWidth - target?.offsetWidth) {
        const cardW = (window.innerWidth / 375) * 320;
        const gapW = (window.innerWidth / 375) * 10;
        const paddingW = (window.innerWidth / 375) * 25;
        const n = Math.floor(Math.abs(endsX - paddingW) / (cardW + gapW));
        const r = (Math.abs(endsX - paddingW) % (cardW + gapW)) / (cardW + gapW);
        setActive(r >= 0.5 ? n + 1 : n);
        // }
    };
    return (
        <div className={`csr-E ${css['csr-E']}`}>
            <div className="secE">
                <div className="content-box">
                    <div className="text-box">
                        <p className="title">{t('secE_title')}</p>
                        <p className="desc">{t('secE_desc')}</p>
                    </div>
                    <div className="card-box">
                        <div className="card-lists" onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                            {cards?.map((card: any, k: number) => (
                                <div className={`card card${k + 1}`} onClick={() => clickCard(card)} key={k}>
                                    <div className="img">
                                        <NextImage webpSrc={card?.webpImg || card.img} src={card.img} alt={card?.title} aria-label={card?.title} />
                                    </div>
                                    <div className="text-bar">
                                        <p className="text">{card?.title}</p>
                                        <SVGArrow />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="paginations">
                            {cards?.map((_: any, k: number) => (
                                <span className={`dot ${active === k ? 'active' : ''}`} key={k}></span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {visible && <CardModal title={modalInfo?.title} desc={modalInfo?.desc} imgs={modalInfo?.imgs} onClose={() => setVisible(false)} />}
        </div>
    );
}
